module.exports = __webpack_public_path__ + "static/media/glow.991a947e.png";